/* Kokunu bul: tek ekranda tek soru (sections/scent-quiz.liquid); durum sessionStorage'da.
   Sonuçtaki hızlı "Sepete ekle" sections/scent-quiz.liquid içindeki javascript etiketindedir. */
(function () {
if (window.DedeSQ) { window.DedeSQ.scan(); return; }
var D = document, RM = matchMedia('(prefers-reduced-motion: reduce)'), EASE = 'cubic-bezier(.2,.7,.2,1)';
function all(s, r) { return [].slice.call(r.querySelectorAll(s)); }
function pad(n) { return n < 10 ? '0' + n : '' + n; }

/* çoğunluk harfi; eşitlikte son cevap, o eşitlerden değilse eşitlerden ilk işaretlenen */
function winner(a) {
  var c = {}, m = 0, last = a[a.length - 1], k;
  a.forEach(function (x) { c[x] = (c[x] || 0) + 1; if (c[x] > m) m = c[x]; });
  if (c[last] === m) return last;
  for (k = 0; k < a.length; k++) if (c[a[k]] === m) return a[k];
}

/* "Koku testi vitrini" bölümünden ya da elle verilen adresten gelen kısayol:
   ?baslangic=ev → ev yolu, ?baslangic=ben → kendim yolu */
function jumpPath() {
  var m = /[?&]baslangic=([^&#]*)/.exec(location.search);
  if (!m) return '';
  var v = decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().toLowerCase();
  return v === 'ev' ? 'home' : v === 'ben' ? 'self' : '';
}
/* adres çubuğundan temizle: sayfa yenilenince ilerleme kaybolmasın */
function dropParam() {
  if (!history.replaceState) return;
  var q = location.search.replace(/([?&])baslangic=[^&#]*(&?)/, function (x, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
  try { history.replaceState(null, '', location.pathname + q + location.hash); } catch (e) {}
}

function init(root) {
  if (root._sq) return;
  var $ = function (s) { return root.querySelector(s); };
  var KEY = 'dede-sq:' + root.getAttribute('data-sq');
  var Q = { home: all('[data-sq-q][data-path="home"]', root), self: all('[data-sq-q][data-path="self"]', root) };
  var start = $('[data-sq-start]'), stage = $('[data-sq-stage]'), bar = $('[data-sq-bar]'),
      live = $('[data-sq-live]'), track = $('[data-sq-track]'), cnt = $('[data-sq-count]'), lab = $('[data-sq-label]');
  var st = { p: '', a: [], i: -1 }, cur = start, timer = 0, sayT = 0, shown = 0;

  try {
    var j = JSON.parse(sessionStorage.getItem(KEY));
    if (j && Q[j.p] && Q[j.p].length) {
      /* editörde blok seçimiyle atlanan soru boş kalabilir; mağazada ilk boşta durulur */
      var n = Q[j.p].length, a = [], k, ed = window.Shopify && Shopify.designMode;
      for (k = 0; k < n; k++) { if (/^[ABC]$/.test((j.a || [])[k])) a[k] = j.a[k]; else if (!ed) break; }
      st = { p: j.p, a: a, i: Math.max(-1, Math.min(+j.i || 0, ed ? n : a.length, n)) };
    }
  } catch (e) {}

  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function say(t) { clearTimeout(sayT); live.textContent = ''; sayT = setTimeout(function () { live.textContent = t; }, 80); }
  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function mark(el) {
    var rs = all('.sq-a', el), v = st.a[st.i], on = 0;
    rs.forEach(function (r, k) { var c = r.getAttribute('data-val') === v; r.setAttribute('aria-checked', c); if (c) on = k; });
    rs.forEach(function (r, k) { r.tabIndex = k === on ? 0 : -1; });
  }
  /* ölçülü geçiş: yalnızca opaklık ve kaydırma; hareket azaltılmışsa yalnızca solma */
  function anim(el, dir) {
    if (!el.animate || !dir) return;
    var K = function (t) { return [{ opacity: 0, transform: t }, { opacity: 1, transform: 'none' }]; };
    el.animate(K('translateX(' + (RM.matches ? 0 : dir * 20) + 'px)'), { duration: RM.matches ? 160 : 260, easing: EASE });
    if (!RM.matches) all('.sq-a,.sq-path', el).forEach(function (c, k) {
      c.animate(K('translateY(10px)'), { duration: 260, delay: 60 + k * 45, easing: EASE, fill: 'backwards' });
    });
  }
  function render(focus, dir, el) {
    var qs = Q[st.p] || [], n = qs.length, res;
    if (!el) {
      if (!n || st.i < 0) el = start;
      else if (st.i < n) el = qs[st.i];
      else {
        var L = winner(st.a), sel = '[data-sq-r][data-path="' + st.p + '"]';
        el = $(sel + '[data-letter="' + L + '"]') || $('[data-sq-r="x"]');
      }
    }
    res = el.hasAttribute('data-sq-r');
    if (cur !== el) { cur.classList.remove('is-on'); el.classList.add('is-on'); cur = el; shown = Date.now(); anim(el, dir); }
    bar.hidden = el === start;
    if (el.hasAttribute('data-sq-q')) mark(el);
    var done = res ? n : Math.min(st.i + 1, n);
    track.style.setProperty('--sq-p', n ? done / n : 0);
    var label = root.getAttribute('data-l-' + st.p) || '';
    lab.textContent = label;
    cnt.innerHTML = res ? 'Sonuç' : '<b>' + pad(st.i + 1) + '</b> / ' + pad(n);
    if (!focus) return;
    /* telefonda yukarı kayınca geri gelen yapışkan başlığın altında dur */
    var h = el.querySelector('[data-sq-h]'), top = stage.getBoundingClientRect().top, hd = D.querySelector('[data-header]'),
        off = hd && getComputedStyle(hd.parentNode).position == 'sticky' ? hd.offsetHeight : 0, up = top < off;
    if (h) h.focus({ preventScroll: true });
    if (up || top > innerHeight / 2) scrollTo({ top: pageYOffset + top - (up ? off : 0) - 16, behavior: RM.matches ? 'auto' : 'smooth' });
    say(el === start ? text(h) : res ? 'Sonucun hazır: ' + text(h) : label + ', soru ' + (st.i + 1) + ' / ' + n + ': ' + text(h));
  }
  function go(i, dir) {
    clearTimeout(timer);
    st.i = Math.max(-1, Math.min(i, (Q[st.p] || []).length));
    save(); render(true, dir);
  }

  function onClick(e) {
    var t = e.target.closest && e.target.closest('a,button');
    if (!t || !root.contains(t)) return;
    /* yeni ekran açılır açılmaz gelen dokunma, önceki ekrandaki çift dokunmanın ikincisidir: yok say (klavye hariç) */
    if (e.detail && Date.now() - shown < 400 && cur.contains(t)) { e.preventDefault(); return; }
    if (t.tagName == 'A') return;
    if (t.classList.contains('sq-a')) {
      if (cur !== t.closest('[data-sq-q]')) return;
      st.a[st.i] = t.getAttribute('data-val');
      save(); mark(cur);
      clearTimeout(timer);
      timer = setTimeout(function () { go(st.i + 1, 1); }, 420);
      return;
    }
    var p = t.getAttribute('data-sq-go');
    if (p && Q[p] && Q[p].length) { if (p !== st.p) st.a = []; st.p = p; go(0, 1); }
    else if (t.hasAttribute('data-sq-back')) go(st.i - 1, -1);
    else if (t.hasAttribute('data-sq-restart')) { st.a = []; go(0, -1); }
  }
  /* oklar cevaplar arasında gezer; Enter/Boşluk seçer */
  function onKey(e) {
    var r = e.target.closest && e.target.closest('.sq-a');
    if (!r) return;
    var rs = all('.sq-a', r.parentNode), k = rs.indexOf(r), n = rs.length,
        m = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1, Home: -k, End: n - 1 - k }[e.key];
    if (m === undefined) return;
    e.preventDefault();
    var x = rs[(k + m + n) % n];
    rs.forEach(function (y) { y.tabIndex = y === x ? 0 : -1; });
    x.focus();
  }
  var EV = { click: onClick, keydown: onKey }, t;
  for (t in EV) root.addEventListener(t, EV[t]);
  root._sq = {
    kill: function () {
      for (t in EV) root.removeEventListener(t, EV[t]);
      clearTimeout(timer); clearTimeout(sayT); root._sq = null;
    },
    /* editörde seçilen soru / sonuç bloğunu göster */
    show: function (b) {
      clearTimeout(timer);
      var p = b.getAttribute('data-path');
      if (!Q[p] || !Q[p].length) return;
      if (p !== st.p) st.a = [];
      st.p = p;
      if (b.hasAttribute('data-sq-q')) { st.i = Q[p].indexOf(b); render(false, 0); }
      else { st.i = Q[p].length; render(false, 0, b); }
      shown = 0;
    }
  };
  root.classList.add('sq--js', 'sq--on');
  /* anasayfadan gelindiyse başlangıç ekranını atla ve o yolun ilk sorusuyla aç */
  var jp = jumpPath();
  if (jp && Q[jp] && Q[jp].length) { st = { p: jp, a: [], i: 0 }; save(); dropParam(); }
  render(false, 0);
  root.classList.remove('sq--wait');
}

function scan(scope) { all('[data-sq]', scope || D).forEach(init); }
D.addEventListener('shopify:section:load', function (e) { scan(e.target); });
D.addEventListener('shopify:section:unload', function (e) { all('[data-sq]', e.target).forEach(function (r) { if (r._sq) r._sq.kill(); }); });
D.addEventListener('shopify:block:select', function (e) {
  var b = e.target, r = b && b.closest && b.closest('[data-sq]');
  if (r && r._sq && (b.hasAttribute('data-sq-q') || b.hasAttribute('data-sq-r'))) r._sq.show(b);
});
window.DedeSQ = { scan: scan };
scan();
})();
